// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import { toSnakeCase } from "@justpark/helpers/src/caseConverter/caseConverter";
import debug from "../helpers/debug";

import type {
  ThreeDS2Challenge,
  SeasonTicketCheckoutDetails,
  ChallengeResponse
} from "../types";

const checkoutSeasonTickets = (
  data: SeasonTicketCheckoutDetails,
  threeDS2: null | ThreeDS2Challenge,
  challengeResponse: null | ChallengeResponse
): ((apiInstance: AxiosInstance) => AxiosPromise<>) => (apiInstance) => {
  debug("checkoutSeasonTickets", data, threeDS2, challengeResponse);

  const threeDSParams = challengeResponse || threeDS2;
  return apiInstance.post(`/v5/season-tickets/checkout`, {
    ...toSnakeCase({ ...data, ...threeDSParams })
  });
};

export default checkoutSeasonTickets;
